import { AfterViewInit, Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { PageHeader } from '../../../../utils/models/page-header';
import { AgendaPriority } from '../../models/agendapriority';
import { AgendaPriorityService } from '../../services/agendapriority.service';
import { CoreSaveService, ConfigService, UtilsService, MessageService, ICommonMessage, FieldType } from '@gbs-platform-client/fwk-core';
import { NotificationsService } from '@gbs-platform-client/building-blocks';
import { DatePipe } from '@angular/common';
import { APIResponse } from 'src/app/utils/models/response';
import { takeUntil } from 'rxjs/operators';
import { forkJoin, Subject } from 'rxjs';
import { ExcelExportComponent } from '@progress/kendo-angular-excel-export';
import { BasicMasterService } from '../../services/basicmaster.service';
import { BasicMaster } from '../../models/basicmaster';
@Component({
  selector: 'app-agendapriority',
  templateUrl: './agendapriority.component.html',
  styleUrls: ['./agendapriority.component.css']
})
export class AgendaPriorityComponent implements OnInit {
  @ViewChild('excelexport', { static: false }) excelexport!: ExcelExportComponent;
  @ViewChild('view') view!: TemplateRef<any>;
  private unsubscribe$: Subject<void> = new Subject<void>();
  headerAgendaPriority: PageHeader;
  entity: AgendaPriority = new AgendaPriority();
  editingEntity: AgendaPriority = new AgendaPriority();
  selectedAgendaPriority: AgendaPriority = new AgendaPriority();
  agendaprioritys: any;
  agendapriorityColumns: any[]=[];
  listView: boolean = true;
  formCaption: string = '';
  pipe = new DatePipe('en-US');
  emailcheck: boolean = true;
  defaultRowsCount: number;
  defaultPageSize: number;
  pageSkip: number = 0;
  pageSizes: any = [];
  saveDisabled: boolean = false;
  basicmaster: Array<BasicMaster> = [];
  selectedOrder: any;
  opened: boolean = false;
  details: any;
  constructor(
    private _agendapriorityService: AgendaPriorityService,
    private configService: ConfigService,
    private _coreSaveService: CoreSaveService,
    private messageService: MessageService,
    private notification: NotificationsService,
    private _basicMasterService: BasicMasterService,
  ) {
    this.headerAgendaPriority = this.initPageHeader();
    this.defaultRowsCount = Number(this.configService.getConfigValue('defaultRowsCount'));
    this.defaultPageSize = Number(this.configService.getConfigValue('defaultPageSize'));
    this.pageSizes = this.configService.getConfigValue('pageSizes');
    
    this.agendaprioritys = [];
    this.getAllAgendaPrioritys();
  }
  ngAfterViewInit(): void {
    this.agendapriorityColumns = [
      { field: "SlNo", title: 'SL No.', filter: false, sortable: true, width: 50 },
      { field: "AgendaPriorityName", title: 'Priority', filter: true, sortable: true, width: 120 },
      { field: "Description", title: 'Description', filter: true, sortable: true, width: 120 },
      { field: "OrderNo", title: 'Order', filter: true, sortable: true, width: 100 },
      { field: "Active", title: 'Active', filter: false, sortable: true, width: 100 },
      { field: "", title: '', filter: true, sortable: true, width: 60, template: this.view } 
    ];

  }
  onPaginationChange(event: any) {
    if (this.defaultPageSize != event.take) {
      this.defaultPageSize = event.take;
    }
    this.pageSkip = event.skip;
    this._agendapriorityService.getAllAgendaPriority('', this.defaultPageSize, ((this.pageSkip / this.defaultPageSize) + 1), 0, 0).subscribe((entities: Array<AgendaPriority>) => {
      this.agendaprioritys = {
        data: entities,
        total: entities[0] ? entities[0].TotalCount : 0
      }
    });
  }

  onFilterChange(event: any): void {
    if (((event && event.filter && event.filter.filters[0] && event.filter.filters[0].filters[0]) != null)) {
      var filter = (event.filter.filters[0].filters[0].field + '|' + event.filter.filters[0].filters[0].value + ';');
      //1 for gridfilter type
      this._agendapriorityService.getAllAgendaPriority(filter, this.defaultPageSize, ((this.pageSkip / this.defaultPageSize) + 1), 1, 0).subscribe((agendaprioritys: Array<AgendaPriority>) => {
        this.agendaprioritys = {
          data: agendaprioritys,
          total: agendaprioritys[0] ? agendaprioritys[0].TotalCount : 0
        }
      });
    }
  }
  getAllAgendaPrioritys() {
    this._agendapriorityService.getAllAgendaPriority('', Number(this.defaultPageSize), 1, 0, 0).subscribe((agendaprioritys: Array<AgendaPriority>) => {
      this.agendaprioritys = {
        data: agendaprioritys,
        total: agendaprioritys[0].TotalCount
      }
    });
  }
  ngOnInit(): void {
    this.messageService.activeCommonMessage.pipe(takeUntil(this.unsubscribe$)).subscribe((message: ICommonMessage | null) => {
      if (message?.eventName === 'delete_read_confirmation') {
        if (message?.param.action === "FA") {
          this._agendapriorityService.deleteAgendaPriority(this.selectedAgendaPriority.Agenda_Priority_Id).subscribe((entity: any) => {
            this.notification.showSuccess('Deleted Successfully');
            this.clearAgendaPriority();
            this.getAllAgendaPrioritys();
          },
          )
        }
      }
    });
  }
  goToBackTab(): void {
    this.listView=true;
  }
  AlphabetsOnly(event: any): boolean {
    var inp = String.fromCharCode(event.keyCode);
    if (/^[a-zA-Z\s]*$/.test(inp)) {
      return true;
    } else {
      return false;
    }
  }
  getAllVenue_type(filter: string) {
    this._basicMasterService.getBasicMastersByName('AGENDAPRIORITY', filter, this.defaultRowsCount, 1).subscribe((data: Array<BasicMaster>) => {
      this.basicmaster = data;
    })
  }
  initPageHeader(): PageHeader {
    let headerAgendaPriority = new PageHeader();
    headerAgendaPriority.PageCaption = "Agenda Priority";
    headerAgendaPriority.IconClass = "bi bi-building";
    return headerAgendaPriority;
  }

  deleteAgendaPriority(event: any) {
    if (event.seletedRows[0]) {
      this.selectedAgendaPriority.Agenda_Priority_Id = event.seletedRows[0];
      var message: ICommonMessage = {
        eventName: "showDialog",
        param: {
          content: "Do you want to delete this entry ?",
          caption: "Agenda Priority",
          returnKey: "delete_read_confirmation"
        }
      };
      this.messageService.sendCommonMessage(message);
    }
  }

  addAgendaPriority(event: any) {
    this.listView = false;
    this.clearAgendaPriority();
    this.formCaption = "Add Agenda Priority";
  }

  editAgendaPriority(event: any): void {
    if (event.seletedRows[0]) {
      this._agendapriorityService.viewAgendaPriority(event.seletedRows[0]).subscribe((agendaprioritys: Array<AgendaPriority>) => {
        let editAgendaPriority = agendaprioritys[0] ? agendaprioritys[0] : new AgendaPriority();
        if (editAgendaPriority) {
          this.editingEntity = editAgendaPriority;
          this.entity = { ...this.editingEntity };
          this.listView = false;
          this.formCaption = "Edit Agenda Priority";
          this.entity.EntityMetaData = [
            { FieldName: 'AgendaPriorityName', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'Priority Name is required' },
            { FieldName: 'OrderNo', FieldType: FieldType.Integer, IsMandatory: true, ValidationMessage: 'Order No. is required' },

          ];
        }
      });
    }
  }

  save(event: any): void {
    this.saveDisabled = true;
    let validations = this._coreSaveService.saveValidation(this.entity);
    if (validations.length === 0) {
      if(this.entity.OrderNo==0||this.entity.OrderNo==undefined){
        this.notification.showWarning('Order No. is required');
        this.saveDisabled = false;
      }
      else{
          this._agendapriorityService.checkDuplication(this.entity.AgendaPriorityName, this.entity.Agenda_Priority_Id).subscribe((res) => {
        if (res.Success == false) {
          this.notification.showWarning('Agenda Priority already exists');
          this.saveDisabled = false;
        }
        else {
          this._agendapriorityService.saveAgendaPriority(this.entity).subscribe(() => {
            if (this.entity.Agenda_Priority_Id == "00000000-0000-0000-0000-000000000000") {
              this.notification.showSuccess('Saved Successfully');
            }
            else {
              this.notification.showSuccess('Updated Successfully');
            }
            this.listView = true;
            this.clearAgendaPriority();
            this.getAllAgendaPrioritys();
          })
        }
      });
    }
    }

    else {
      this.saveDisabled = false;
    }
  }

  gotoBack(): void {
    this.listView = true;
    this.clearAgendaPriority();
  }
  refreshAgendaPriority(event: any): void {
    this.agendaprioritys=[];
    this.getAllAgendaPrioritys();
  }
  clearAgendaPriority(): void {
    this.entity = new AgendaPriority();
    this.saveDisabled = false;
  }
  onExcelExport() {
    this.excelexport.save()
  }
  revertChanges(): void {
    this.entity = { ...this.editingEntity };
  }
  numberOnly(event: any): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }
  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
  public close() {
    this.opened = false;
  }
  public open(dataItem: any): void {
    this.entity.Agenda_Priority_Id = dataItem.Agenda_Priority_Id;
    this.details = [];
    this._agendapriorityService.viewAgendaPriority(this.entity.Agenda_Priority_Id).subscribe((agendaprioritys: Array<AgendaPriority>) => {
      this.opened = true;
      this.details = agendaprioritys[0];
    })}
}
